const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ||
  'http://localhost:5000';

const platforms = [
  {
    id: 'tatacliq',
    name: 'Tata CLiQ',
    color: '#0073AE',
    approved: true,
    searchUrl: (query, filters) => {
      let url = `https://www.tatacliq.com/search/?searchCategory=all&text=${encodeURIComponent(query)}`;
      if (filters?.maxPrice) url += `&max_price=${filters.maxPrice}`;
      if (filters?.minPrice) url += `&min_price=${filters.minPrice}`;
      return url;
    },
  },
  {
    id: 'myntra',
    name: 'Myntra',
    color: '#FF3F6C',
    approved: true,
    searchUrl: (query, filters) => {
      const MYNTRA_AFFILIATE_ID = 'HNEfQzdzzZ';
      let url = `https://www.myntra.com/search?rawQuery=${encodeURIComponent(query)}&sort=popularity`;
      if (filters?.maxPrice) url += `&price=0to${filters.maxPrice}`;
      url += `&utm_source=ugc_affiliate`;
      url += `&utm_medium=fitthea_app`;
      url += `&utm_campaign=${MYNTRA_AFFILIATE_ID}`;
      url += `&affiliate_id=${MYNTRA_AFFILIATE_ID}`;
      return url;
    },
  },
  {
    id: 'ajio',
    name: 'Ajio',
    color: '#F26522',
    approved: true,
    searchUrl: (query, filters) => {
      let url = `https://www.ajio.com/search/?text=${encodeURIComponent(query)}`;
      if (filters?.maxPrice) url += `&price-range=0-${filters.maxPrice}`;
      return url;
    },
  },
  {
    id: 'meesho',
    name: 'Meesho',
    color: '#9B59B6',
    approved: true,
    searchUrl: (query) => {
      return `https://meesho.com/search?q=${encodeURIComponent(query)}`;
    },
  },
  {
    id: 'nykaa',
    name: 'Nykaa Fashion',
    color: '#FC2779',
    approved: false,
    searchUrl: (query, filters) => {
      let url = `https://www.nykaafashion.com/search/result?q=${encodeURIComponent(query)}`;
      if (filters?.maxPrice) url += `&pmax=${filters.maxPrice}`;
      return url;
    },
  },
];

const buildSearchKeyword = (parsed) => {
  const parts = [];
  const isMen = parsed?.gender === 'men';

  if (parsed?.category) parts.push(parsed.category);

  if (parsed?.fabric?.length > 0) {
    const importantFabrics = [
      'silk', 'cotton', 'georgette', 'chiffon',
      'banarasi', 'kanjivaram', 'chanderi', 'linen',
      'denim', 'velvet', 'crepe', 'modal', 'brocade',
    ];
    const matched = parsed.fabric.find(f =>
      importantFabrics.includes(f.toLowerCase())
    );
    if (matched) parts.push(matched);
  }

  if (parsed?.colors?.length > 0 &&
    parsed.colors[0] !== 'multicolor') {
    parts.push(parsed.colors[0]);
  }

  if (isMen) parts.push('men');

  return parts.join(' ') || parsed?.category || 'fashion';
};

export const parseSearchQuery = async (
  userQuery,
  bodyShape = null,
  gender = null,
  savedSize = null,
  savedBottomSize = null
) => {
  try {
    console.log('Calling Claude backend for:', userQuery);

    const response = await fetch(
      `${BACKEND_URL}/api/claude-search`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userQuery,
          bodyShape,
          gender,
          savedSize,
          savedBottomSize,
        }),
      }
    );

    if (!response.ok) {
      console.error('Claude backend error:', response.status);
      return null;
    }

    const parsed = await response.json();

    if (parsed.error) {
      console.error('Claude error:', parsed.error);
      return null;
    }

    const searchKeyword = parsed.searchKeyword ||
      buildSearchKeyword(parsed);

    const platformResults = platforms.map(platform => ({
      ...platform,
      url: platform.searchUrl(searchKeyword, parsed),
      searchKeyword,
      timestamp: Date.now(),
    }));

    console.log('Claude response:', parsed);

    return {
      ...parsed,
      platformResults,
      searchKeyword,
    };

  } catch (error) {
    console.error('Error calling Claude backend:', error);
    return null;
  }
};

export const searchProductsFromBackend = async (
  searchFilters,
  userId = 'guest'
) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}/api/search-products`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          keyword: searchFilters.searchKeyword ||
            searchFilters.category,
          userId,
          gender: searchFilters.gender,
          maxPrice: searchFilters.maxPrice,
          minPrice: searchFilters.minPrice,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 403) {
      return {
        type: 'limit_reached',
        message: data.message,
        isGuest: data.isGuest,
        resetAfterHours: data.resetAfterHours,
      };
    }

    return data;

  } catch (error) {
    console.error('Backend search error:', error);
    return { type: 'error', error: error.message };
  }
};

export const getOutfitSuggestions = async (
  productName,
  bodyShape,
  gender
) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}/api/claude-search`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userQuery: `Suggest outfit to pair with ${productName}`,
          bodyShape,
          gender,
          savedSize: null,
          savedBottomSize: null,
        }),
      }
    );

    const data = await response.json();
    if (data.error) return null;
    return data;

  } catch (error) {
    console.error('Outfit suggestions error:', error);
    return null;
  }
};